// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  // apiUrl: 'http://localhost:8080'
  // apiUrl : 'https://68.178.162.180:8080/cs_pma_clone'
  apiUrl: 'https://184.168.121.208:8080/sve'

};
// ! live tomcat server  http://184.168.121.208:8080/sve
// ? local server  http://192.168.0.16:8080
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.